import CIMSTable from 'components/CIMSTable'
import { useExpand } from './hooks/useExpand'
import { useTestingLabsContext } from './TestingLabsContext'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useRemove } from './hooks/useRemove'
import { useEdit } from './hooks/useEdit'

const TestingLabs: React.FC = () => {
  const { refetch: onReload, fetching, testingLabs } = useTestingLabsContext()
  const columns = useColumns()
  const expand = useExpand()
  const create = useCreate()
  const remove = useRemove()
  const edit = useEdit()
  return (
    <CIMSTable
      records={testingLabs}
      rowKey="id"
      columns={columns}
      loading={fetching}
      actions={{ header: { onReload, create }, row: { remove, edit } }}
      expand={expand}
    />
  )
}

export default TestingLabs
